<template>
  <v-dialog v-model="dialog" max-width="450" persistent>
    <v-card class="validation-alert">
      <v-card-title class="alert-header">
        <v-icon color="warning" size="24" class="mr-2">mdi-alert-circle</v-icon>
        <span class="alert-title">입력 확인</span>
        <v-spacer></v-spacer>
      </v-card-title>
      
      <v-divider></v-divider>
      
      <v-card-text class="alert-content">
        <p class="alert-message mb-3">다음 항목을 확인해주세요:</p>
        <ul class="error-list">
          <li v-for="(error, index) in errors" :key="index" class="error-item">
            <v-icon color="error" size="16" class="mr-2">mdi-close-circle</v-icon>
            {{ error }}
          </li>
        </ul>
      </v-card-text>
      
      <v-divider></v-divider>
      
      <v-card-actions class="alert-actions">
        <v-spacer></v-spacer>
        <v-btn 
          color="primary" 
          text 
          @click="close"
          class="confirm-btn"
        >
          확인
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ValidationAlert',
  data() {
    return {
      dialog: false,
      errors: [],
    };
  },
  methods: {
    show(errorList) {
      this.errors = Array.isArray(errorList) ? errorList : [errorList];
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.errors = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.validation-alert {
  border-radius: 8px;
  
  .alert-header {
    background-color: #fff3cd;
    color: #856404;
    padding: 16px 20px;
    
    .alert-title {
      font-weight: 600;
      font-size: 16px;
    }
  }
  
  .alert-content {
    padding: 20px;
    
    .alert-message {
      color: #6c757d;
      font-size: 14px;
      margin-bottom: 12px;
    }
    
    .error-list {
      margin: 0;
      padding: 0;
      list-style: none;
      
      .error-item {
        display: flex;
        align-items: center;
        padding: 8px 12px;
        margin-bottom: 4px;
        background-color: #fff5f5;
        border-left: 3px solid #f56565;
        border-radius: 4px;
        color: #e53e3e;
        font-size: 14px;
        
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  
  .alert-actions {
    padding: 12px 20px;
    background-color: #f8f9fa;
    
    .confirm-btn {
      min-width: 80px;
      font-weight: 600;
    }
  }
}

// 다크 테마 대응 (필요시)
.theme--dark .validation-alert {
  .alert-header {
    background-color: #3a3a3a;
    color: #ffd700;
  }
  
  .alert-content .error-list .error-item {
    background-color: #4a1a1a;
    color: #ff6b6b;
  }
  
  .alert-actions {
    background-color: #2a2a2a;
  }
}
</style> 